<p-toast></p-toast>
<form [formGroup]="currencyForm" class="p-fluid">
  <hr class="mt-0 mb-4" />
  <div class="p-4">
    <div class="flex flex-column gap-2 mb-4">
      
      <!-- Currency Name Field -->
      <div class="field grid">
        <label for="currencyName" class="col-12 md:col-4 font-medium">
          {{ 'layout.configurations.currency.form.currencyName' | translate }}
          <span class="text-red-500">*</span>
        </label>

        <div class="col-12 md:col-8">
          <input 
            type="text" 
            id="currencyName"
            formControlName="currencyName"
            pInputText 
            class="w-full"
            placeholder="{{ 'layout.configurations.currency.form.currencyName' | translate }}"
          />
          <small 
            *ngIf="isFieldInvalid('currencyName')" 
            class="text-red-500"
          >
            {{ getErrorMessage('currencyName') }}
          </small>
        </div>
      </div>

      <!-- Status Field -->
      <div class="field grid">
        <label for="status" class="col-12 md:col-4 font-medium">
          {{ 'layout.configurations.currency.form.status' | translate }}
          <span class="text-red-500">*</span>
        </label>

        <div class="col-12 md:col-8">
          <p-dropdown
            id="status"
            formControlName="status"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            placeholder="{{ 'layout.configurations.currency.form.status' | translate }}"
          ></p-dropdown>
          <small 
            *ngIf="isFieldInvalid('status')" 
            class="text-red-500"
          >
            {{ getErrorMessage('status') }}
          </small>
        </div>
      </div>

    </div>
  </div>

  <!-- Form Actions -->
  <div class="flex justify-content-end gap-2 mt-4">
    <p-button 
      [label]="isEditMode ? ('layout.configurations.currency.form.update' | translate) : ('layout.configurations.currency.form.create' | translate)"
      [icon]="isEditMode ? 'pi pi-check' : 'pi pi-save'"
      type="button"
      (onClick)="onSave()"
      [loading]="isLoading"
      [disabled]="currencyForm.invalid || isLoading"
    ></p-button>
    <p-button 
      label="{{ 'layout.configurations.currency.form.cancel' | translate }}"
      icon="pi pi-times"
      severity="danger"
      class="p-button-outlined"
      type="button"
      (onClick)="onCancel()"
    ></p-button>
  </div>

</form>